import React from 'react';
import { Item, Post, ArticleContent, ArticleImg, ArticleTitle, Info, ThumbnailImg } from './styles';

export const CardPost = ({ url, thumbnail, title, date, landing }) => {
	return (
		<Item landing={landing} href={url} target="_blank" rel="noopener noreferrer">
			<Post>
				<ArticleImg landing={landing} path={url}>
					<div className="gatsby-image-wrapper" style={{ position: 'relative', overflow: 'hidden' }}>
						<div style={{ width: '100%', paddingBottom: '55.1453%' }} />
						<ThumbnailImg src={thumbnail} alt={title} />
					</div>
				</ArticleImg>
				<ArticleContent>
					<ArticleTitle path={url}>{title}</ArticleTitle>
					<Info path={url}>Updated on {date}</Info>
				</ArticleContent>
			</Post>
		</Item>
	);
};
